@import "../../../../common/base";
@import "../../../../common/icons";

@include button-reset();
@include box-sizing();

:host {
  display: grid;
  grid-template-rows: min-content;
}

.action {
  display: grid;
  grid-template:
    "stretch-start block-start stretch-end" max-content
    "stretch-start inline-caption stretch-end" max-content
    "stretch-start block-end stretch-end" max-content / max-content 1fr max-content;
}

// TODO: Fix "inline-caption: start" items support
.align-container {
  display: grid;
  grid-auto-flow: column;
  // Don't add (grid-auto-columns: max-content), because it will break the align-end
  white-space: break-spaces; // Support for line breaks, like \n
}

// - - - - - - - - - - - - - - - - - - - -
//         First level containers
// - - - - - - - - - - - - - - - - - - - -
.stretch-start {
  grid-area: stretch-start;
}

.block-start {
  grid-area: block-start;
}

.inline-caption {
  grid-area: inline-caption;
  align-items: center;
  min-block-size: var(--ch-action-list-item__image-size);
}

.block-end {
  grid-area: block-end;
}

.stretch-end {
  grid-area: stretch-end;
}

.stretch-start,
.stretch-end {
  align-self: stretch;
}

// - - - - - - - - - - - - - - - - - - - -
//         Second level containers
// - - - - - - - - - - - - - - - - - - - -
.align-start {
  display: flex;
  justify-self: flex-start;
}

.align-center {
  display: flex;
  justify-self: center;
}

.align-end {
  display: flex;
  justify-self: flex-end;
}

.valign-start {
  display: flex;
  align-self: self-start;
}

.valign-center {
  display: flex;
  align-self: center;
}

.valign-end {
  display: flex;
  align-self: self-end;
}

// - - - - - - - - - - - - - - - - - - - -
//            Additional items
// - - - - - - - - - - - - - - - - - - - -
:host(:not(:hover):not(:focus-within)) .show-on-mouse-hover {
  display: none;
}

.additional-item {
  display: inline-grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  align-items: center;
}

.fix,
.modify,
.remove,
.confirm-action,
.cancel-action {
  &::before {
    content: "";
    display: inline-block;
    inline-size: var(--ch-action-list-item__image-size);
    block-size: var(--ch-action-list-item__image-size);
    content-visibility: auto;
    contain-intrinsic-size: auto var(--ch-action-list-item__image-size);
    -webkit-mask: no-repeat center /
      var(--ch-action-list-item__background-image-size) var(--ch-start-start);
    background-color: var(--ch-action-list-item__action-color);
  }
}

.fixed {
  --ch-start-start: var(--ch-action-list-item__additional-item-fixed-image);
}

.not-fixed {
  --ch-start-start: var(--ch-action-list-item__additional-item-not-fixed-image);
}

.modify {
  --ch-start-start: var(--ch-action-list-item__additional-item-modify-image);
}

.remove {
  --ch-start-start: var(--ch-action-list-item__additional-item-remove-image);
}

.confirm-action {
  --ch-start-start: var(--ch-action-list-item__additional-item-confirm-image);
}

.cancel-action {
  --ch-start-start: var(--ch-action-list-item__additional-item-cancel-image);
}

// - - - - - - - - - - - - - - - - - - - -
//                 Images
// - - - - - - - - - - - - - - - - - - - -
@include images-without-pseudo-elements(
  $image-path-custom-var: var(--ch-start-start),
  $image-size-custom-var: var(--ch-action-list-item__image-size),
  $background-image-size-custom-var:
    var(--ch-action-list-item__background-image-size)
);

@include images-with-pseudo-elements(
  $start-image-path-custom-var: var(--ch-start-start),
  $end-image-path-custom-var: var(--ch-end-img),
  $image-size-custom-var: var(--ch-action-list-item__image-size),
  $background-image-size-custom-var:
    var(--ch-action-list-item__background-image-size)
);

.additional-item.not-actionable {
  --ch-start-start: var(--ch-start-img--base);

  .action:active &.start-img--active {
    --ch-start-start: var(--ch-start-img--active);
  }

  .action:focus &.start-img--focus {
    --ch-start-start: var(--ch-start-img--focus);
  }

  .action:hover &.start-img--hover {
    --ch-start-start: var(--ch-start-img--hover);
  }

  .action:disabled &.start-img--disabled {
    --ch-start-start: var(--ch-start-img--disabled);
  }
}
